<div class="page">
  @if (isServer || assetCount() === undefined) {
    <app-loading-indicator></app-loading-indicator>
  } @else if (archive()) {
    @if (archive()) {
      <div class="page-content">
        @if (archive().archive.status === 'resizing') {
          <div class="archive-icon-container">
            <app-circle-progress-bar
              [progress]="archive().resizeProgress"
              [size]="62"
              [strokeWidth]="12"
              [noBackgroundCircle]="true"
            ></app-circle-progress-bar>
            <img src="/assets/animations/download-resizing.svg" alt="" />
          </div>

          <h1>Resizing Images</h1>
          <p class="standard-text">
            {{ archive().assetResizingDoneCount }} of {{ archive().assetCount }} images resized.
          </p>
        } @else if (archive().completed) {
          <div class="archive-icon-container">
            <app-animated-svg src="/assets/animations/checkmark.svg"></app-animated-svg>
          </div>

          @if (archive().partInfo) {
            <h1>Downloading ZIP {{ archive().partInfo.index + 1 }} of {{ archive().partInfo.total }}</h1>
          } @else {
            <h1>Download Started</h1>
          }

          <p class="standard-text">
            {{ archive().assetCount }} assets, {{ archive().archive.total_size | dataUnitsBigInt: 0 }}.
          </p>
        } @else if (archive().progress) {
          <div class="archive-icon-container">
            <app-circle-progress-bar
              [progress]="archive().progress"
              [size]="126"
              [strokeWidth]="12"
              [noBackgroundCircle]="true"
            ></app-circle-progress-bar>
            <img src="/assets/animations/download-zipping.svg" alt="" />
          </div>

          @if (archive().partInfo) {
            <h1>Creating ZIP {{ archive().partInfo.index + 1 }} of {{ archive().partInfo.total }}</h1>
          } @else {
            <h1>Creating ZIP-File</h1>
          }
          <p class="standard-text">
            {{ archive().progress | number: '1.0-0' }}% of
            {{ archive().archive.total_size | dataUnitsBigInt: 0 }} zipped.
          </p>
        } @else if (archive().errored) {
          <div class="icon-container">
            <app-svg src="/assets/icons/download.svg"></app-svg>
          </div>

          <h1>Download Failed</h1>
          <p class="standard-text">An error occurred while downloading the gallery. Please try again later.</p>
        } @else {
          <div class="archive-icon-container">
            <img src="/assets/animations/download-preparing.svg" alt="" />
          </div>

          <h1>Preparing Download</h1>
          <p class="standard-text">Collecting {{ archive().assetCount }} assets.</p>
        }
        @if (!archive().completed && !archive().errored) {
          <button
            class="cta"
            appButton
            name="cancel"
            location="gallery-download-page"
            spacing="3"
            shape="round"
            (click)="archiveService.cancelArchive(archive())"
          >
            Cancel Download
          </button>
        }
      </div>
    }
  } @else if (canDownload()) {
    <div class="page-content">
      <div class="icon-container">
        <app-svg src="/assets/icons/download.svg"></app-svg>
      </div>

      <h1>Download Gallery</h1>

      <p class="standard-text">{{ assetCount() | number }} assets, {{ totalSize() | dataUnitsBigInt }}</p>

      <button
        appButton
        name="download"
        location="gallery-download-page"
        color="primary"
        shape="round"
        spacing="3"
        class="cta"
        (click)="startDownload()"
      >
        Start Download
      </button>
    </div>
  } @else {
    <div class="page-content">
      <div class="icon-container">
        <app-svg src="/assets/icons/download.svg"></app-svg>
      </div>

      <h1>Download Unavailable</h1>

      <p class="standard-text">This gallery is not available for download.</p>
    </div>
  }
</div>
